export enum VisibleField {
  Name = "Name",
  Type = "Type",
  Intro = "Intro",
  Description = "Description",
  HideFieldName = "HideFieldName",
  IsMultiSelect = "IsMultiSelect",
  IsRequired = "IsRequired",
  IsStaffOnly = "IsStaffOnly",
  UseForMobileNumber = "UseForMobileNumber",
  UseForEmailAddress = "UseForEmailAddress",
  TextboxPlaceholderValue = "TextboxPlaceholderValue",
  ValueLabel = "ValueLabel",
  Value = "Value",
  UnsetValue = "UnsetValue",
  IntegrationObject = "IntegrationObject",
  SortKeyValuePairsByValue = "SortKeyValuePairsByValue",
  KeyValuePairs = "KeyValuePairs",
  DateSelectedMinRelativeTimePeriod = "DateSelectedMinRelativeTimePeriod",
  DateSelectedMaxRelativeTimePeriod = "DateSelectedMaxRelativeTimePeriod",
  FeeAmounts = "FeeAmounts",
}
